export { default } from './withArtistRecommendations';
